import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {EventEmitter, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {CommandService} from '@core/services/command.service';
import {DialogService} from '@shared/services/dialog-service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {FileManagementService} from '@core/services/file-management.service';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {
  SetActivityFeedAction, SetCurrentRightSideComponentAction
} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {Store} from '@ngrx/store';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {PlatformSidebarService} from '@shared/components/platform-sidebar/store/platform-sidebar.service';
import {FuseSidebarService} from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';
import {Api} from '@shared/constants/common-field.constants';
import {Guid} from 'guid-typescript';
import {ValidatorHelper} from "@shared/components/platform-tool/platform-tool-dialog-definition/models/validators-model";
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {IVirtualGridCollectionState} from '@shared/store/reducers/virtual-grid.reducer';
import {ResetVirtualGridAction} from '@shared/store/actions/virtual-grid.actions';

@Injectable({
  providedIn: 'root',
})
export class ScenariosHandler implements IPlatformToolHandler {
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  magicLinkModel: MagicLinkModel;
  selectedTabModel: TabModel;
  ngUnsubscribe = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  sourceType = 'ITC-Scenario';

  constructor(private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private platformQueryService: PlatformQueryService,
              private platformSidebarService: PlatformSidebarService,
              private virtualGridStore: Store<IVirtualGridCollectionState>,
              private sidebarService: FuseSidebarService
  ) {
    ValidatorHelper.registerDateFilter('ScenarioTemplateUpdaterDateFilter', (d: Date | null): boolean => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const day = (d || new Date()).getDay();
      return d>=today;
    })
  }

  executeCommand(command: PlatformCommand) {
    command = JSON.parse(JSON.stringify(command));
    console.log('[itc-scenarios-platform-command] onPlatformTool Handler Command', command);

    if (!command.fieldValues['ScenarioType'] && this.magicLinkModel.fieldValues['ScenarioType']) {
      command.fieldValues['ScenarioType'] = this.magicLinkModel.fieldValues['ScenarioType'];
    }

    if (command.fieldValues['CommandHandler']) {
      const commandHandler = RootDynamicComponentHelper.getComponent(command.fieldValues['CommandHandler']);
      if (commandHandler) {
        commandHandler.executeCommand(command, this, null);
        return;
      }
    }
    switch (command.name) {
      // case 'ToggleGridFilterByProjectCommand':
      //   this.handleToggleGridFilterByProjectCommand(command);
      //   break;
      case 'ToggleGridFilterByArchiveCommand':
        this.handleToggleGridFilterByArchiveCommand(command);
        break;
      case 'ToggleGridFilterBySolutionCommand':
        this.handleToggleGridFilterBySolutionCommand(command);
        break;
      default:
        this.executeCommandToApi(command);
        break;
    }
  }

  // private handleToggleGridFilterByProjectCommand(command: PlatformCommand) {
  //   const updateViewCommand = new PlatformCommand('CreateScenarioToolLinkCommand', Api.Spreadsheet);
  //   updateViewCommand.fieldValues['ShowAllProjectsScenario'] = command.isChecked;
  //   updateViewCommand.fieldValues['ScenarioType'] = command.fieldValues['ScenarioType'];
  //   this.fuseSplashScreenService.show();
  //   this.commandService.executePlatformCommand(updateViewCommand).pipe(take(1)).subscribe(response => {
  //       console.log('commandState', response);
  //       if (response.fieldValues['PlatformLinkModel']) {
  //
  //         this.magicLinkModel = response.fieldValues['PlatformLinkModel'];
  //
  //         this.magicLinkModelValueChangedHandler({
  //           id: 'PlatformToolContainerComponent', value: response.fieldValues['PlatformLinkModel'],
  //           magicLinkModel: this.magicLinkModel
  //         });
  //       } else {
  //         console.log('Platform link model not found');
  //         this.fuseSplashScreenService.hide();
  //       }
  //     },
  //     error => {
  //       this.fuseSplashScreenService.hide();
  //       console.error('Operation failed!!!', error);
  //     });
  // }

  private handleToggleGridFilterBySolutionCommand(command: PlatformCommand) {
    const updateViewCommand = new PlatformCommand('CreateScenarioToolLinkCommand', Api.Spreadsheet);
    updateViewCommand.fieldValues['ShowAllSolutionsScenario'] = command.isChecked;
    updateViewCommand.fieldValues['ShowArchivedScenario'] = command.fieldValues['ShowArchivedScenario'];
    updateViewCommand.fieldValues['ScenarioType'] = command.fieldValues['ScenarioType'];
    updateViewCommand.fieldValues['ViewType'] = command.fieldValues['ViewType'];
    updateViewCommand.projectId = command.projectId;
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(updateViewCommand).pipe(take(1)).subscribe(response => {
        this.handleUpdateViewCommandResponse(response);
      },
      error => {
        this.handleUpdateViewCommandError(error);
      });
  }

  private handleToggleGridFilterByArchiveCommand(command: PlatformCommand) {
    let updateViewCommand = new PlatformCommand('CreateScenarioToolLinkCommand', Api.Spreadsheet);
    if (command.fieldValues['MasterScenarioId'] !== null ) {
      updateViewCommand = new PlatformCommand('CreateSubScenarioToolLinkCommand', Api.Spreadsheet);
      updateViewCommand.fieldValues['MasterScenarioId'] = command.fieldValues['MasterScenarioId'];
    }

    updateViewCommand.fieldValues['ShowArchivedScenario'] = command.isChecked;
    updateViewCommand.fieldValues['ShowAllSolutionsScenario'] = command.fieldValues['ShowAllSolutionsScenario'];
    updateViewCommand.fieldValues['ScenarioType'] = command.fieldValues['ScenarioType'];
    updateViewCommand.fieldValues['ViewType'] = command.fieldValues['ViewType'];
    updateViewCommand.projectId = command.projectId;
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(updateViewCommand).pipe(take(1)).subscribe(response => {
        this.handleUpdateViewCommandResponse(response);
      },
      error => {
        this.handleUpdateViewCommandError(error);
      });
  }

  private handleUpdateViewCommandResponse(response: PlatformCommandResponse){
    console.log('commandState', response);
    if (response.fieldValues['PlatformLinkModel']) {

      this.magicLinkModel = response.fieldValues['PlatformLinkModel'];

      this.magicLinkModelValueChangedHandler({
        id: 'PlatformToolContainerComponent', value: response.fieldValues['PlatformLinkModel'],
        magicLinkModel: this.magicLinkModel
      });
    } else {
      console.log('Platform link model not found');
      this.fuseSplashScreenService.hide();
    }
  }

  private handleUpdateViewCommandError(error: any){
    this.fuseSplashScreenService.hide();
    console.error('Operation failed!!!', error);
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
    if (this.handleByFieldDefinition($event)) {
      return;
    }
  }

  destroy() {
    if (this.sidebarService.getSidebar('rightsidebar')) {
      this.sidebarService.getSidebar('rightsidebar').close();
      this.sidebarService.getSidebar('rightsidebar').fold();
    }
    this.platformSidebarService.hideSidebarIcon('ITC Scenario');
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setSelectedTab(selectedTab: TabModel): void {
    if(selectedTab.tabData?.DetailsHelpId &&
      ((!this.magicLinkModel.fieldValues.hasOwnProperty('FlowId')  || this.magicLinkModel.fieldValues.FlowId == null) && (!this.magicLinkModel.fieldValues.hasOwnProperty('NodeId')  || this.magicLinkModel.fieldValues.NodeId == null)))  {
      // ! [MAGIC-BAR-AUTO-OPEN]
      this.platformSidebarStore.dispatch(
        new SetCurrentRightSideComponentAction(
          {component: 'HelpNotesComponent', data: {isUserAction: false}, componentInfo: {id: 'HelpNotesComponent'}}));
    }
    this.navigateToScenarioFilter(selectedTab.id);

  }
  private navigateToScenarioFilter(selectedTabId="") {
    let url=this.router.url;
    if (selectedTabId === "Scenario-Filter") {
      if (!url.endsWith("/filter")) {
        url += "/filter";
      }
    } else {
      if (url.endsWith("/filter")) {
        url = url.slice(0, -"/filter".length);
      }
    }
    this.router.navigateByUrl(url);
  }
  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      command.projectId = '[PROJECT_ID]';
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('[ITC-Scenario-platform-command] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['ErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['SnackBarMessage']);
          }

          if (commandResponse.fieldValues['FileId']) {
            const fileId = commandResponse.fieldValues['FileId'];
            const fileName = commandResponse.fieldValues['FileName'];
            this.downloadFile(fileId, fileName);
          }
          if (commandResponse.fieldValues['PlatformLinkModel']) {
            this.magicLinkModel = commandResponse.fieldValues['PlatformLinkModel'];
            this.magicLinkModelValueChangedHandler({
              id: 'PlatformToolContainerComponent', value: commandResponse.fieldValues['PlatformLinkModel'],
              magicLinkModel: this.magicLinkModel
            });
            return;
          }

          this.invalidateSubject.invalidate();
        },
        error => {
          console.log(error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  private handleCommand($event): boolean {
    if ($event.command) {
      switch ($event.command.name) {
        case 'CommandName':
          return true;
        default:
          this.executeCommand($event.command);
          return true;
      }
    }
    return false;
  }

  private handleAction($event): boolean {
    if ($event.action) {
      console.log('Action ID: ' + $event.action.id);
      const item = $event.item;
      const command = this.magicLinkModel.additionalCommands[$event.action.id];
      if (command) {
        command.fieldValues['ItemId'] = $event.item.id;
        command.fieldValues['ScenarioId'] = $event.item.cells['ScenarioId']?.value ? $event.item.cells['ScenarioId']?.value : $event.item.id;
        //command.fieldValues['ScenarioId'] = item.id;
        command.fieldValues['IsClosed'] = this.isClosed(item);
        command.fieldValues['SelectedFieldKey'] = $event.action.id;
        this.executeCommand(command);
        return true;
      }
      switch ($event.action.id) {
        case 'Edit':
          this.edit($event);
          return true;
        case 'Archive':
          this.archiveScenario($event.item, true);
          return true;
        case 'UnArchive':
          this.archiveScenario($event.item, false);
          return true;
        case 'ShowActivity':
          this.showActivity($event.item);
          return true;
        case 'Delete':
          this.deleteScenario($event.item);
          return true;
        case 'RollForward':
          this.rollForwardScenario($event.item);
          return true;
        case 'Duplicate':
          this.duplicateScenario($event.item);
          return true;
        case 'CreateSupportTicket':
          this.createSupportTicket($event.item);
          return true;
        case 'ShowSnapshots':
          this.onShowSnapshotButtonClick($event.item);
          return true;
        case 'ManagePermissions':
          this.onManagePermissions($event.item);
          return true;
        case 'LockScenario':
          this.onLockScenario($event.item);
          return true;
        case 'ApplyFieldSchema':
          this.onApplySchema($event.item);
          return true;
        case 'UnlockScenario':
          this.onUnlockScenario($event.item);
          return true;
        case 'ScenarioSettings':
          this.onScenarioSetting($event.item);
          return true;
        case 'RequestAccess':
          this.onAccessRequest($event.item);
          return true;
        case 'AddFilter':
          this.onAddFilterClick($event.item);
          return true;
        // SA-E-251-01: the List View items run the same commands as the Card View's ToMaster / ToNormal.
        // SA-E-251-02: like the Card View, which hides them, they do nothing on a locked scenario.
        case 'AssignComplianceScenario':
          if (!this.isLockedRow($event.item)) {
            this.ToMaster($event.item);
          }
          return true;
        case 'UnassignComplianceScenario':
          if (!this.isLockedRow($event.item)) {
            this.ToNormal($event.item);
          }
          return true;
      }
    }
    return false;
  }
  onAddFilterClick(data: any) {
    const platformCommand = new PlatformCommand('AddOrUpdateScenarioFilterCommand', Api.Spreadsheet);
    platformCommand.fieldValues['data'] = data;
    platformCommand.fieldValues['ScenarioId'] = data.id;
    platformCommand.fieldValues['ScenarioType'] = data.cells['CurrentScenarioType']?.value;
    this.executeCommand(platformCommand);
  }
  private edit($event) {
    this.openEditor($event);
  }

  private openEditor($event) {
    const originalValue = $event.item.cells[$event.fieldDefinition.key]?.value;
    this.dialogService.showCellEditorDialog($event.item, $event.fieldDefinition).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      if (state && state.action === 'OK') {
        const item = {id: $event.item.id, fieldValues: {}};
        const value = $event.item.cells[$event.fieldDefinition.key].value;
        item.fieldValues[$event.fieldDefinition.key] = value;
        const command = new PlatformCommand('EditScenarioFieldCommand', Api.Spreadsheet);
        command.fieldValues['ScenarioId'] = $event.item.id;
        command.fieldValues['FieldKey'] = $event.fieldDefinition.key;
        command.fieldValues[$event.fieldDefinition.key] = value;
        command.fieldValues['Value'] = value;
        command.fieldValues['FieldHeader'] = $event.fieldDefinition.header;
        this.executeCommand(command);
      } else {
        // change back to original value
        $event.item.cells[$event.fieldDefinition.key].value = originalValue;
      }
    });
  }

  public archiveScenario(item, isArchive) {
    const archiveScenarioCommand = new PlatformCommand('ArchiveScenarioCommand', Api.Spreadsheet);
    archiveScenarioCommand.setValue('ScenarioType', this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType']);
    archiveScenarioCommand.projectId =  this.magicLinkModel.tabBar.tabs[0].tabData['ProjectId'];
    archiveScenarioCommand.setValue('Id', item.id);
    const showArchived = this.magicLinkModel.tabBar.tabs[0]?.tabData?.ShowArchived || false;
    archiveScenarioCommand.setValue('ShowArchivedScenario', showArchived);
    archiveScenarioCommand.setValue('IsArchive', isArchive);
    if (isArchive) {
      this.dialogService.showYesNoDialog('Archive Scenario', 'Are you sure you want to archive the Scenario?').subscribe(response => {
        if (response?.action === 'OK') {
          this.commandService.executePlatformCommand(archiveScenarioCommand).subscribe(commandResponse => {
            this.invalidateSubject.invalidate();
          });
        }
      });
    } else {
      this.commandService.executePlatformCommand(archiveScenarioCommand).subscribe(commandResponse => {
        this.invalidateSubject.invalidate();
      });
    }

  }

  public deleteScenario(item) {
    const deleteScenarioCommand = new PlatformCommand('DeleteScenarioCommand', Api.Spreadsheet);
    deleteScenarioCommand.setValue('ScenarioType', this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType']);
    deleteScenarioCommand.setValue('ScenarioId', item.id);
    deleteScenarioCommand.projectId = '[PROJECT_ID]';
    this.dialogService.showYesNoDialog('Delete Scenario', 'Are you sure you want to delete the Scenario?').subscribe(response => {
      if (response?.action === 'OK') {
        this.fuseSplashScreenService.show();
        this.commandService.executePlatformCommand(deleteScenarioCommand).subscribe(commandResponse => {
          this.fuseSplashScreenService.hide();
          this.invalidateSubject.invalidate();
        });
      }
    });
  }

  public onShowSnapshotButtonClick(item) {
    const command = this.magicLinkModel.additionalCommands['CreateSnapshotToolLinkCommand'] as PlatformCommand;
    command.fieldValues['ScenarioId'] = item.id;
    this.executeCommand(command);
  }

  onManagePermissions(item) {
    const managePermissionCommand = new PlatformCommand('ManagePermissionDialogCommand', Api.Security);
    managePermissionCommand.waitForResponse = true;

    managePermissionCommand.fieldValues['DataPointId'] = item.id;
    managePermissionCommand.fieldValues['FeatureId'] =  this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType'];
    this.commandService.executePlatformCommand(managePermissionCommand);
  }

  onScenarioSetting(item) {
    const scenarioSettingsUpdateCommand = new PlatformCommand('ScenarioSettingsUpdateCommand', Api.Spreadsheet);
    scenarioSettingsUpdateCommand.waitForResponse = true;
    scenarioSettingsUpdateCommand.setValue('ScenarioType', this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType']);
    scenarioSettingsUpdateCommand.setValue('ScenarioId', item.id);
    scenarioSettingsUpdateCommand.projectId = '[PROJECT_ID]';
    scenarioSettingsUpdateCommand.setValue('PlatformLinkId', this.magicLinkModel.id);
    this.executeCommandToApi(scenarioSettingsUpdateCommand);
  }

  onAccessRequest(item) {
    const requestAccessCommand = new PlatformCommand('RequestAccessDialogCommand', Api.Security);
    requestAccessCommand.waitForResponse = true;

    requestAccessCommand.fieldValues['DataPointId'] = item.id;
    requestAccessCommand.fieldValues['FeatureId'] = this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType'];
    requestAccessCommand.fieldValues['DataPointName'] = item.cells['ScenarioName']?.value;

    this.commandService.executePlatformCommand(requestAccessCommand);
  }

  onUnlockScenario(item) {
    const currentScenarioType = this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType'];
    if(this.isScheduledScenario(currentScenarioType, item)){
      this.manageUpdate(item);
      return;
    }
    const command = this.magicLinkModel.additionalCommands['UnlockScenarioCommand'] as PlatformCommand;
    command.fieldValues['ScenarioId'] = item.id;
    this.executeCommand(command);
  }

  onLockScenario(item) {
    const command = this?.magicLinkModel.additionalCommands['LockScenarioCommand'] as PlatformCommand;
    command.fieldValues['ScenarioId'] = item.id;
    this.executeCommand(command);
  }

  isScheduledScenario(scenarioType, item){
    const templateUpdateChoices = {
      'GMT': item.cells[`UpdateChoice-GMT`]?.value,
      'ITC': item.cells[`UpdateChoice-ITC`]?.value
    };
    if(templateUpdateChoices[scenarioType]){
      return templateUpdateChoices[scenarioType].updateSettings === 'ScheduleUpdates';
    }
    return false;
  }


  public createSupportTicket(item) {
    if(this.magicLinkModel.additionalCommands
      && this.magicLinkModel.additionalCommands.hasOwnProperty('CreateScenarioSupportTicket')) {
      const createScenarioSupportTicketCommand = this.magicLinkModel.additionalCommands['CreateScenarioSupportTicket'];
      createScenarioSupportTicketCommand.fieldValues['ticketId'] = Guid.create().toString();
      createScenarioSupportTicketCommand.fieldValues['ScenarioId'] = item.id;
      const scenarioName = item.cells['ScenarioName'].value;
      createScenarioSupportTicketCommand.fieldValues['ToastNotificationMessage'] = (createScenarioSupportTicketCommand.fieldValues['ToastNotificationMessage']).replace('[ScenarioName]', scenarioName);
      // const attachments = createScenarioSupportTicketCommand.fieldValues['Attachments'];
      // attachments[0].attachmentTitle = `${scenarioName}.zip(Preparing...)`;
      this.commandService.executePlatformCommand(createScenarioSupportTicketCommand);
    }
  }

  public duplicateScenario(item) {
    const copyScenarioCommand = new PlatformCommand('CopyScenarioCommand', Api.Spreadsheet);
    copyScenarioCommand.setValue('ScenarioType', this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType']);
    copyScenarioCommand.setValue('ScenarioId', item.id);
    copyScenarioCommand.projectId = '[PROJECT_ID]';
    this.executeCommandToApi(copyScenarioCommand);
  }
  public rollForwardScenario(item) {
    const copyScenarioCommand = new PlatformCommand('CopyScenarioCommand', Api.Spreadsheet);
    copyScenarioCommand.setValue('ScenarioType', this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType']);
    copyScenarioCommand.setValue('ScenarioId', item.id);
    copyScenarioCommand.setValue('RollForward', true);
    copyScenarioCommand.projectId = '[PROJECT_ID]';
    this.executeCommandToApi(copyScenarioCommand);
  }

  private isClosed(item: any): boolean {
    return item.cells['IsClosed'] && item.cells['IsClosed'].value;
  }

  private handleByFieldDefinition($event): boolean {
    const command = this.magicLinkModel.additionalCommands[$event.fieldDefinition.key];
    if (command) {
      switch ($event.fieldDefinition.key) {
        case 'FieldSchemaName':
          command.fieldValues['SchemaId'] = $event.item.cells['FieldSchemaName']?.value;
          command.fieldValues['FieldSchemaNodeId'] = $event.item.cells['FieldSchemaName']?.value;
          break;
        default:
          command.fieldValues['ItemId'] = $event.item.id;
          command.fieldValues['ScenarioId'] = $event.item.cells['ScenarioId']?.value ? $event.item.cells['ScenarioId']?.value : $event.item.id;
          command.fieldValues['SelectedFieldKey'] = $event.fieldDefinition.key;
          break;
      }
      this.executeCommand(command);
      return true;
    }
    return false;
  }

  private downloadFile(fileId: string, fileName: string) {
    this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
      this.fileManagementService.openSaveFileWindow(payload, fileName);
      this.fuseSplashScreenService.hide();
    });
  }


  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }

  public showActivity(item: any) {
    const referenceCode = item.id;
    const title = item.cells['ScenarioName'].value;
    const activityInfo = {type: 'ReferenceCode', 'id': referenceCode, 'title': title, isDefault: false, isUserAction: true};
    this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
  }

  manageUpdate(data: any) {
    const updateCommand = new PlatformCommand('CreateScenarioTemplateUpdaterDialogCommand', Api.Spreadsheet);
    var scenarioType = this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType'];
    updateCommand.fieldValues['ScenarioType']=scenarioType;
    updateCommand.fieldValues['ScenarioId']=data.id;
    updateCommand.fieldValues['ScenarioName']=data.cells['ScenarioName']?.value;
    updateCommand.fieldValues['TypeOfUpdate']=data.cells['TypeOfUpdate-'+scenarioType]?.value;
    this.executeCommandToApi(updateCommand);
  }

  // A row is locked when its Tag carries the exact Locked token (not Unlocked) or its IsLocked cell is set,
  // the cell the Card View reads.
  private isLockedRow(item: any): boolean {
    const tags = (item?.cells?.Tag?.value ?? '').toString().split(',').map(tag => tag.trim());
    const isLocked = item?.cells?.IsLocked?.value;
    return tags.includes('Locked') || isLocked === true || isLocked?.toString().toLowerCase() === 'true';
  }

  ToMaster(data: any) {
    const command = new PlatformCommand('InitializeMasterScenarioConversionCommand', Api.Spreadsheet);
    command.fieldValues['ScenarioType']=this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType'];
    command.fieldValues['ScenarioId']=data.id;
    this.executeCommandToApi(command);
  }

  ToNormal(data: any) {

    const command = new PlatformCommand('InitializeUnassignMasterScenarioCommand', Api.Spreadsheet);
    command.fieldValues['ScenarioType']=this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType'];
    command.fieldValues['MasterScenarioId']=data.id;
    this.executeCommandToApi(command);
  }


  onApplySchema(data: any) {
    const getAllSourceTypesQuery = new PlatformQuery();
    getAllSourceTypesQuery.name = 'GetScenarioQuestionnaireSourceTypesQuery';
    getAllSourceTypesQuery.api = Api.Spreadsheet;
    getAllSourceTypesQuery.setValue('ScenarioType', this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType']);
    getAllSourceTypesQuery.setValue('ScenarioId', data.id);
    this.platformQueryService.executeQuery(getAllSourceTypesQuery).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => {
       console.log('apply field schema query response:', response);
      if (response && response.fieldValues && response.fieldValues.hasOwnProperty('SourceTypes')) {
        const sourceTypes = response.fieldValues['SourceTypes'];
        this.ClearFieldSections(sourceTypes);
        const changeScenarioFieldSchemaCommand = new PlatformCommand('ChangeScenarioFieldSchemaCommand', Api.Spreadsheet);
        changeScenarioFieldSchemaCommand.setValue('ScenarioType', this.magicLinkModel.tabBar.tabs[0].tabData['ScenarioType']);
        changeScenarioFieldSchemaCommand.setValue('ScenarioId', data.id);
        changeScenarioFieldSchemaCommand.setValue('UpdateSingleQnr', false);
        this.executeCommandToApi(changeScenarioFieldSchemaCommand);
      }
    });
  }

  private ClearFieldSections(sourceTypes: Array<string>) {
      if (sourceTypes && sourceTypes.length > 0) {
       sourceTypes.forEach(sourceType => {
         this.virtualGridStore.dispatch(new ResetVirtualGridAction(sourceType));
       });
      }
  }
}
